// const BASE_API_URL = 'http://127.0.0.1:5002';
const BASE_API_URL = 'https://tucasaapi.afriscape.co.tz';

export default BASE_API_URL;
